import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type ScoreLevel } from '@kirigami/domain/analysis-types';
import { ICONS_REGISTRY } from './icons.registry';
import { SvgSanitizerPipe } from './svg-sanitizer.pipe';

/**
 * Renders the L1..L4 score glyph. Size and color variant are input
 * signals so the template can reflect them reactively.
 */
@Component({
  selector: 'kirigami-score-icons',
  standalone: true,
  imports: [CommonModule, SvgSanitizerPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="score-icons__container" [attr.aria-label]="ariaLabel()" [class]="containerClass()">
      @if (iconsMap[score()]) {
        <div class="score-icons__svg" [innerHTML]="iconsMap[score()] | svgSanitizer"></div>
      } @else {
        <span>Icon not found</span>
      }
    </div>
  `,
  styleUrls: ['./score-icons.scss'],
  host: { class: 'score-icons' },
})
export class ScoreIcons {
  score = input<ScoreLevel>('l1');
  size = input<'large' | 'medium' | 'small'>('large');
  color = input<'heavy' | 'light'>('heavy');

  iconsMap = ICONS_REGISTRY;

  containerClass = computed(() =>
    ['score-icons__container', `score-icons__container--${this.size()}`].join(' '),
  );

  ariaLabel = computed(() => {
    const map: Record<string, string> = {
      l1: 'Level 1',
      l2: 'Level 2',
      l3: 'Level 3',
      l4: 'Level 4',
    };
    return map[this.score()] ?? 'Score icon';
  });
}
